"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Error500Logo from "../../public/assets/error_500_logo.svg";
import multiplyLogo from "@public/assets/multiply_navbar_logo.svg";
import { Button } from "@mui/material";
import Link from "next/link";
export default function GlobalErrorPage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-center items-center  flex-col h-full grow "><div className="pb-[56px]"><Image src={multiplyLogo} alt="logo" sizes="100%" className="w-[220px] h-[51px]  " priority={true} /></div><Image src={Error500Logo} alt="logo" /><h1 className="text-[24px] font-bold  ">500</h1><p className="text-[14px] text-[#6F6F6F] ">Internet Server Error</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="min-h-screen flex flex-col justify-center items-center bg-white ">{t0}<div className="h-[72px] flex justify-center items-center bg-white border-t-2 border-[#E4E3DB61] p-2 "><Link href="/"><Button variant="contained" className="!rounded-[100px] grow !bg-[#004BEE] $">Back to Home</Button></Link></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}